/**
 * 根据Baidu地图Api 获取经纬度
 * @param {container : '绘制地图的容器' , city : '城市名称',callback : '查询或点击标注后调用，将传递经纬度'}
 */
var BMapLib = function(param) {
    var obj = new Object();
    //地图的创建
    var CUR_IMG = "http://api.map.baidu.com/library/MarkerTool/1.2/src/images/transparent.cur"; //鼠标透明样式，发布时候修改为绝对路径
    var ICON_IMG = "http://api.map.baidu.com/library/MarkerTool/1.2/src/images/us_mk_icon.png"; //图标样式，发布时候修改为绝对路径
    var map = new BMap.Map(param.container);
    map.centerAndZoom(param.city, 12);
    map.enableScrollWheelZoom(); //启用滚轮放大缩小，默认禁用
    map.enableContinuousZoom(); //启用地图惯性拖拽，默认禁用

    map.addControl(new BMap.NavigationControl()); //添加默认缩放平移控件
    map.addControl(new BMap.OverviewMapControl()); //添加默认缩略地图控件
    map.addControl(new BMap.OverviewMapControl({
        isOpen: true,
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT
    })); //右下角，打开
    var localSearch = new BMap.LocalSearch(map);
    localSearch.enableAutoViewport(); //允许自动调节窗体大小
    map.setDefaultCursor("url(" + CUR_IMG + "), default"); //设置鼠标样式            
    //标注
    var followMarker = null; //跟随鼠标移动的标注
    var changeMarker = null; //选中位置后的标注
    var searchMarker = null; //查询结果的标注
    //标注的初始化
    (function() {
        if (!followMarker) {
            followMarker = new BMap.Marker(map.getCenter(), {
                offset: new BMap.Size(-5, -5)
            }); //偏移-10像素,解决cursor问题
            map.addOverlay(followMarker);
            followMarker.setZIndex(1000); // 设置跟随Marker的z轴高度
            followMarker.hide();
        }
        if (!changeMarker) {
            changeMarker = new BMap.Marker(map.getCenter(), {
                offset: new BMap.Size()
            }); //偏移-10像素,解决cursor问题
            map.addOverlay(changeMarker);
            changeMarker.setZIndex(999); // 设置跟随Marker的z轴高度
            changeMarker.hide();
        }
    })();

    //相关属性的声明
    (function() {
        obj.PX = map.getCenter().lng; //经度
        obj.PY = map.getCenter().lat; //纬度
        //根据名称查询地理位置,请求有点慢
        obj.searchByStationName = function(keyword) {

            localSearch.setSearchCompleteCallback(function(searchResult) {
                var poi = searchResult.getPoi(0);
                map.centerAndZoom(poi.point, 13);
                if(searchMarker){searchMarker.remove();}
                searchMarker = new BMap.Marker(new BMap.Point(poi.point.lng, poi.point.lat)); // 创建标注，为要查询的地方对应的经纬度
                map.addOverlay(searchMarker);
                changeMarker.hide();
                if (param.callback) {
                    param.callback(poi.point.lng, poi.point.lat);
                }
            });
            localSearch.search(keyword);
        };
    })();

    //事件监听处理
    (function() {
        //标注点跟随鼠标移动
        map.addEventListener('mousemove', function(e) {
            var pt = e.point;
            followMarker.setIcon(ICON_IMG); //每次都检查最新的Icon
            followMarker.setPosition(pt);
            followMarker.show();
        });
        //单击地图进行标注
        map.addEventListener("click", function(e) {
            if (searchMarker) {
                searchMarker.remove();
            }
            //经纬度坐标
            obj.PX = e.point.lng;
            obj.PY = e.point.lat;
            //绘制标注的坐标
            var x = e.pixel.x - 5;
            var y = e.pixel.y - 5;
            var iconPix = new BMap.Pixel(x, y); //创建点坐标
            changeMarker.setPosition(map.pixelToPoint(iconPix));
            changeMarker.show();
            if (param.callback) {
                param.callback(obj.PX, obj.PY);
            }
        });
    })();
    /**
    * 设置标注
    */
    obj.setMarker = function(point){
        if(searchMarker){searchMarker.remove();}
        searchMarker = new BMap.Marker(point); // 创建标注，为要查询的地方对应的经纬度
        map.addOverlay(searchMarker);
    };
    return obj;
};
module.exports = BMapLib;



/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/BMap.js
 ** module id = 123
 ** module chunks = 0
 **/